/* ===================================================================
   TUAS · Klaviyo Reviews — comportamento
   -------------------------------------------------------------------
   1. Corrige o preserveAspectRatio do SVG da barra do fit
   2. Constroi a linha de contexto ao lado do nome:
      Regular Feet | Usual Size: 38 | Ordered Size: 38
   3. Trunca o comentario (3 linhas desktop / 2 mobile) + Read more
   4. Mostra as reviews por blocos: 3 no desktop / 2 no mobile,
      e "Read more reviews" revela mais 3 de cada vez

   Todo o aspecto esta em custom-tuas-reviews.css.
   =================================================================== */

(function () {
  'use strict';

  var CONFIG = {
    firstDesktop: 3,   // quantas aparecem de inicio no desktop
    firstMobile:  2,   // quantas aparecem de inicio no mobile
    step:         3,   // quantas mais a cada clique
    mobileMQ:     '(max-width: 749px)',
    debug:        false
  };

  var SEL = {
    wrapper:  '#klaviyo-product-reviews-wrapper',
    item:     '.kl_reviews__review_item',
    content:  '.kl_reviews__review__content',
    list:     '.kl_reviews__list_container',
    header:   '.kl_reviews__summary__header',
    author:   '.kl_reviews__review__author',
    qaBlock:  '.kl_reviews__custom_question_answer',
    fitSvg:   '.kl_reviews__summary__custom_question--range svg'
  };

  /* ---------------------------------------------------------------
     Traducoes
     --------------------------------------------------------------- */
  var UI = {
    en: { more: 'Read more', less: 'Read less', all: 'Read more reviews',      title: 'Reviews' },
    pt: { more: 'Ler mais',  less: 'Ler menos', all: 'Ver mais avaliações',    title: 'Avaliações' },
    es: { more: 'Leer más',  less: 'Leer menos', all: 'Ver más opiniones',     title: 'Opiniones' },
    fr: { more: 'Lire plus', less: 'Lire moins', all: 'Voir plus d’avis', title: 'Avis' }
  };

  /* Linha de contexto. 'values' traduz a largura do pe;
     os tamanhos (38) nao se traduzem. */
  var META = {
    en: {
      values:  { narrow: 'Narrow', regular: 'Regular', wide: 'Wide' },
      feet:    function (v) { return v + ' Feet'; },
      usual:   function (v) { return 'Usual Size: ' + v; },
      ordered: function (v) { return 'Ordered Size: ' + v; }
    },
    pt: {
      values:  { narrow: 'estreito', regular: 'normal', wide: 'largo' },
      feet:    function (v) { return 'Pé ' + v; },
      usual:   function (v) { return 'Tamanho habitual: ' + v; },
      ordered: function (v) { return 'Tamanho encomendado: ' + v; }
    },
    es: {
      values:  { narrow: 'estrecho', regular: 'normal', wide: 'ancho' },
      feet:    function (v) { return 'Pie ' + v; },
      usual:   function (v) { return 'Talla habitual: ' + v; },
      ordered: function (v) { return 'Talla pedida: ' + v; }
    },
    fr: {
      values:  { narrow: 'étroit', regular: 'normal', wide: 'large' },
      feet:    function (v) { return 'Pied ' + v; },
      usual:   function (v) { return 'Pointure habituelle : ' + v; },
      ordered: function (v) { return 'Pointure commandée : ' + v; }
    }
  };

  var META_RULES = [
    { match: 'feet',             key: 'feet',    translate: true  },
    { match: 'usual size',       key: 'usual',   translate: false },
    { match: 'size did you get', key: 'ordered', translate: false }
  ];

  var META_SEPARATOR = ' | ';

  function lang() {
    return (document.documentElement.getAttribute('lang') || 'en')
             .slice(0, 2).toLowerCase();
  }

  function t(key) { return (UI[lang()] || UI.en)[key]; }
  function meta()  { return META[lang()] || META.en; }

  function log() {
    if (CONFIG.debug && window.console) {
      console.log.apply(console, ['[TUAS reviews]'].concat([].slice.call(arguments)));
    }
  }

  /* ---------------------------------------------------------------
     1 · SVG da barra do fit
     viewBox="0 0 259 10" com width="100%": sem preserveAspectRatio
     o browser aplica "meet" e centra o desenho, deixando folga dos
     dois lados — era isso que desalinhava a barra do texto.
     --------------------------------------------------------------- */
  function stretchFitBar(wrapper) {
    var svgs = wrapper.querySelectorAll(SEL.fitSvg);
    Array.prototype.forEach.call(svgs, function (svg) {
      if (svg.dataset.tuasStretched) return;
      svg.dataset.tuasStretched = '1';
      svg.setAttribute('preserveAspectRatio', 'none');
    });
  }

  /* ---------------------------------------------------------------
     Titulo da seccao
     --------------------------------------------------------------- */
  function fixHeading(wrapper) {
    if (wrapper.dataset.tuasHeading === '1') return;

    var header = wrapper.querySelector(SEL.header);
    if (!header) return;

    if (/customer\s+reviews/i.test(header.textContent)) {
      header.textContent = t('title');
    }
    wrapper.dataset.tuasHeading = '1';
  }

  /* ---------------------------------------------------------------
     2 · Linha de contexto ao lado do nome
     --------------------------------------------------------------- */
  function readAnswers(item) {
    var out = [];
    var blocks = item.querySelectorAll(SEL.qaBlock);

    Array.prototype.forEach.call(blocks, function (block) {
      var qEl = block.querySelector('[class*="custom_question__question"]');
      if (!qEl) return;

      var textAnswer = block.querySelector('[class*="custom_question__answer--text"]');
      if (!textAnswer) return;   // ignoramos as respostas de range

      var question = (qEl.textContent || '').trim().toLowerCase();
      var value = (textAnswer.textContent || '').trim();

      if (question && value) out.push({ question: question, value: value });
    });

    return out;
  }

  function buildMeta(wrapper) {
    var items = wrapper.querySelectorAll(SEL.item);
    var dict = meta();

    Array.prototype.forEach.call(items, function (item) {
      if (item.dataset.tuasMeta) return;
      item.dataset.tuasMeta = '1';

      var answers = readAnswers(item);
      if (!answers.length) return;

      var parts = [];

      META_RULES.forEach(function (rule) {
        answers.forEach(function (a) {
          if (a.question.indexOf(rule.match) === -1) return;

          var value = a.value;
          if (rule.translate) {
            var normalised = value.toLowerCase();
            if (dict.values[normalised]) value = dict.values[normalised];
          }
          parts.push(dict[rule.key](value));
        });
      });

      if (!parts.length) return;

      var author = item.querySelector(SEL.author);
      if (!author) return;

      var span = document.createElement('span');
      span.className = 'tuas-meta';
      span.textContent = parts.join(META_SEPARATOR);
      author.appendChild(span);
    });
  }

  /* ---------------------------------------------------------------
     3 · Truncar comentarios + Read more
     Reviews escondidas tem altura 0, por isso a medicao daria sempre
     falso. Adiamos essas ate ficarem visiveis.
     --------------------------------------------------------------- */
  function clampReviews(wrapper) {
    var contents = wrapper.querySelectorAll(SEL.content);

    Array.prototype.forEach.call(contents, function (content) {
      if (content.dataset.tuasClamped) return;
      if (!content.offsetParent) return;   // ainda escondida

      content.dataset.tuasClamped = '1';
      content.classList.add('tuas-clamp');

      if (content.scrollHeight <= content.clientHeight + 2) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tuas-more';
      btn.textContent = t('more') + ' →';

      btn.addEventListener('click', function () {
        var stillClamped = content.classList.toggle('tuas-clamp');
        btn.textContent = stillClamped ? t('more') + ' →' : t('less');
      });

      content.parentNode.insertBefore(btn, content.nextSibling);
    });
  }

  /* ---------------------------------------------------------------
     4 · Mostrar por blocos + "Read more reviews"
     --------------------------------------------------------------- */
  function paginate(wrapper) {
    var items = wrapper.querySelectorAll(SEL.item);
    if (!items.length) return;

    var first = window.matchMedia(CONFIG.mobileMQ).matches
      ? CONFIG.firstMobile
      : CONFIG.firstDesktop;

    var visible = parseInt(wrapper.dataset.tuasVisible || '0', 10);
    if (!visible || visible < first) visible = first;
    wrapper.dataset.tuasVisible = visible;

    Array.prototype.forEach.call(items, function (item, i) {
      item.classList.toggle('tuas-collapsed', i >= visible);
    });

    var wrap = wrapper.querySelector('.tuas-viewall-wrap');

    // ja estao todas visiveis
    if (items.length <= visible) {
      if (wrap) wrap.remove();
      return;
    }

    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'tuas-viewall-wrap';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tuas-viewall';
      btn.textContent = t('all');

      btn.addEventListener('click', function () {
        var current = parseInt(wrapper.dataset.tuasVisible || '0', 10);
        wrapper.dataset.tuasVisible = current + CONFIG.step;
        paginate(wrapper);
        clampReviews(wrapper);   // as novas ja estao visiveis: medir agora
      });

      wrap.appendChild(btn);

      var list = wrapper.querySelector(SEL.list);
      if (list) list.appendChild(wrap);
      else items[items.length - 1].parentNode.appendChild(wrap);
    } else {
      // manter o link sempre no fim da lista
      var listEl = wrapper.querySelector(SEL.list);
      if (listEl && wrap.parentNode === listEl) listEl.appendChild(wrap);
    }
  }

  /* ---------------------------------------------------------------
     Orquestracao
     --------------------------------------------------------------- */
  var scheduled = false;

  function apply() {
    if (scheduled) return;
    scheduled = true;

    setTimeout(function () {
      scheduled = false;
      var wrapper = document.querySelector(SEL.wrapper);
      if (!wrapper) return;

      try {
        stretchFitBar(wrapper);
        fixHeading(wrapper);
        buildMeta(wrapper);
        paginate(wrapper);
        clampReviews(wrapper);
      } catch (err) {
        log('erro:', err);
      }
    }, 80);
  }

  function init() {
    log('script carregado');
    apply();

    new MutationObserver(apply).observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener('resize', function () {
      var wrapper = document.querySelector(SEL.wrapper);
      if (!wrapper) return;
      paginate(wrapper);
      clampReviews(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
